import React from 'react';
export function TermsConditions() {
  return <div className="prose prose-sm max-w-none text-[#3D3028]/80" data-id="element-346">
      <h3 className="text-lg font-semibold text-[#3D3028] mb-4" data-id="element-347">
        Términos y Condiciones
      </h3>

      <p className="mb-4" data-id="element-348">Última actualización: Diciembre 2024</p>

      <h4 className="text-base font-semibold text-[#3D3028] mt-6 mb-3" data-id="element-349">
        1. Aceptación de Términos
      </h4>
      <p className="mb-4" data-id="element-350">
        Al acceder y utilizar este curso, aceptas estar sujeto a estos términos
        y condiciones. Si no estás de acuerdo, no debes utilizar nuestros
        servicios.
      </p>

      <h4 className="text-base font-semibold text-[#3D3028] mt-6 mb-3" data-id="element-351">
        2. Acceso al Curso
      </h4>
      <p className="mb-4" data-id="element-352">
        Al completar tu compra, obtendrás acceso inmediato y de por vida al
        contenido del curso, incluyendo videos, materiales descargables y bonos
        exclusivos.
      </p>

      <h4 className="text-base font-semibold text-[#3D3028] mt-6 mb-3" data-id="element-353">
        3. Garantía de Devolución
      </h4>
      <p className="mb-4" data-id="element-354">
        Ofrecemos una garantía de devolución del 100% durante los primeros 7
        días después de tu compra. Si no estás satisfecha con el curso, puedes
        solicitar un reembolso completo sin preguntas.
      </p>

      <h4 className="text-base font-semibold text-[#3D3028] mt-6 mb-3" data-id="element-355">
        4. Propiedad Intelectual
      </h4>
      <p className="mb-4" data-id="element-356">
        Todo el contenido del curso, incluyendo videos, textos, imágenes y
        materiales descargables, está protegido por derechos de autor y es
        propiedad exclusiva de Master Hydra Gloss Lips™.
      </p>

      <h4 className="text-base font-semibold text-[#3D3028] mt-6 mb-3" data-id="element-357">
        5. Uso Permitido
      </h4>
      <p className="mb-4" data-id="element-358">
        El contenido del curso es para tu uso personal y educativo. No está
        permitido:
      </p>
      <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-359">
        <li data-id="element-360">Compartir tu acceso con terceros</li>
        <li data-id="element-361">Reproducir o distribuir el contenido</li>
        <li data-id="element-362">Revender o comercializar los materiales</li>
        <li data-id="element-363">Utilizar el contenido para crear cursos competidores</li>
      </ul>

      <h4 className="text-base font-semibold text-[#3D3028] mt-6 mb-3" data-id="element-364">
        6. Limitación de Responsabilidad
      </h4>
      <p className="mb-4" data-id="element-365">
        El curso proporciona información educativa. Los resultados pueden variar
        según la práctica y dedicación individual. No garantizamos resultados
        específicos.
      </p>

      <h4 className="text-base font-semibold text-[#3D3028] mt-6 mb-3" data-id="element-366">
        7. Modificaciones
      </h4>
      <p className="mb-4" data-id="element-367">
        Nos reservamos el derecho de actualizar el contenido del curso y estos
        términos en cualquier momento. Los cambios significativos serán
        notificados a los usuarios activos.
      </p>

      <h4 className="text-base font-semibold text-[#3D3028] mt-6 mb-3" data-id="element-368">
        8. Jurisdicción
      </h4>
      <p className="mb-4" data-id="element-369">
        Estos términos se rigen por las leyes aplicables. Cualquier disputa será
        resuelta mediante arbitraje o en los tribunales competentes.
      </p>
    </div>;
}